import { Tag } from "antd";

type TypeTagProps = {
  type: string;
};

export default function TypeTag({ type }: TypeTagProps) {
  return <Tag color={"red"}>{type}</Tag>;
}
